import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { CustomButtonComponent } from './components/custom-button/custom-button.component';
import { CustomSearchBoxComponent } from './components/custom-search-box/custom-search-box.component';
import { NoResultsComponent } from './components/no-results/no-results.component';

@NgModule({
  declarations: [
    CustomSearchBoxComponent,
    CustomButtonComponent,
    BreadcrumbsComponent,
    NoResultsComponent,
  ],
  imports: [CommonModule, FormsModule, RouterModule],
  exports: [
    CustomSearchBoxComponent,
    CustomButtonComponent,
    NoResultsComponent,
    BreadcrumbsComponent,
  ],
})
export class SharedModule {}
